import styled from 'styled-components'

export const SocialShareWrapper = styled.div`
  display: flex;
  gap: 6px;

  @media (max-width: 767px) {
    svg {
      width: 28px;
      height: 28px;
    }
  }
`
